import { render, staticRenderFns } from "./ReferralBanner.vue?vue&type=template&id=2ed460ab"
import script from "./ReferralBanner.vue?vue&type=script&lang=js"
export * from "./ReferralBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports